// IE9 Polyfill
import 'core-js/features/array/find-index'
import 'core-js/features/array/includes'
import 'core-js/features/string/includes'
import 'react-app-polyfill/ie11'

import 'normalize.css'

import React from 'react'
import { render } from 'react-dom'
import cssVars from 'css-vars-ponyfill'
import { Logger } from '@mercadona/mo.library.web-services/logger'

import { App } from 'app'
import { TranslationService } from 'services/translation'
import LanguageSelector from './language-selector'
import registerServiceWorker from './services/service-worker'
import { initializeModules } from './module-loader'

import './assets/css/index.css'

cssVars()
Logger.init()
TranslationService.initialize()

const currentLanguage = TranslationService.getCurrentLanguage()
LanguageSelector.initialize(
  currentLanguage,
  updateLanguage,
  TranslationService.applyTranslations,
)

initializeModules(currentLanguage)

function updateLanguage(language) {
  TranslationService.changeLanguage(language)
  renderContent()
}

function renderContent() {
  render(<App />, document.getElementById('root'))
}

renderContent()

registerServiceWorker()
